import React from 'react';
import { GestureResponderEvent, View } from 'react-native';
import { scale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';
import { WithColorProps } from '@styles/colors/types';

export interface ArrowProps extends Pick<WithColorProps, 'C'> {
  color?: string;
  rotate?: number;
  onPress: (event: GestureResponderEvent) => void;
  disabled?: boolean;
  customStyle?: any;
  iconWidth?: number;
  iconHeight?: number;
  testID?: string;
}

export default ({ C, color, rotate = 0, onPress, disabled, customStyle, iconWidth = 11, iconHeight = 16, testID }: ArrowProps) => {
  return (
    <TouchableElement testID={testID} onPress={onPress} disabled={disabled}>
      {({ boxStyle, pressHoverColor }) => (
        <View
          style={[
            !disabled && boxStyle,
            {
              width: scale(32),
              height: scale(32),
              borderRadius: scale(32) / 2,
              backgroundColor: C(pressHoverColor('Button/Light/Secondary')),
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
              opacity: disabled ? 0 : 1,
              ...customStyle,
            },
            rotate > 0 ? { marginLeft: scale(18) } : { marginRight: scale(18) },
          ]}
        >
          <View
            style={[
              {
                transform: [
                  {
                    rotate: `${rotate}deg`,
                  },
                ],
              },
              rotate > 0 ? { marginRight: scale(-2) } : { marginLeft: scale(-2) },
            ]}
          >
            <Svg icon="chevronLeft" width={iconWidth} height={iconHeight} color={color || 'Button/Light/Primary'} />
          </View>
        </View>
      )}
    </TouchableElement>
  );
};
